export default __webpack_public_path__ + "static/media/element_95.17bd7571.jpg";